import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminDigitalOrderConfigsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('digital-order-config');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
